export default __webpack_public_path__ + "static/media/ps_06.1e6a10a3.png";